import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'
import { fetchGrantListItems } from '../../services/listview'
import { RequirementItem } from '@/config/configuration'
export const masterApi = createApi({
  reducerPath: 'masterApi',
  baseQuery: fakeBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getMasterList: builder.query<RequirementItem[], void>({
      queryFn: async () => {
        try {
          const data = await fetchGrantListItems()
          return { data }
        } catch (error) {
          return { error: { status: 'CUSTOM_ERROR', error: String(error) } }
        }
      }
    })
  })
})

export const { useGetMasterListQuery } = masterApi
